import { Trans, useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks/hooks";
import { getSecondWellIsOpen } from "../../store/slices/appSlice";
import Result from "../../components/common/Result";

const EMPTY_RESULTS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

const ResultsSection = () => {
	const { i18n, t } = useTranslation("gasRateCritical");
	const calculator = useAppSelector(state => state.gasRateCriticalCalculator);
	const secondWell = useAppSelector(getSecondWellIsOpen);
	const resultsP = calculator?.results1?.p ?? EMPTY_RESULTS;
	const resultsQ = calculator?.results1?.q ?? EMPTY_RESULTS;

	return (
		<fieldset className="grc__results-section round-corner-container">
			<legend>{t(`results_title`)}</legend>
			<div className="grc__results-well1">
				<div className="grc__results_column_names">
					<div>
						<span>P </span>
						<span className="unit-font-size">
							<Trans
								ns={'gasRateCritical'}
								key={i18n.language}
								i18nKey={t(`measurement_units.pressure.bar`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>
						</span>
					</div>
					<div>
						<span>Q </span>
						<span className="unit-font-size">
							<Trans
								ns={'gasRateCritical'}
								key={i18n.language}
								i18nKey={t(`measurement_units.q.thousand_m3_day`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>
						</span>
					</div>
				</div>

				{resultsP.map((result, i) => {
					return (<div className="grc__result_row result-row" key={`grc-row-${i}`}>
						<Result
							className="grc__result-value-p"
							id={`grc-p-${i}`}
							label={<></>}
							// unit={<>{t(`common:measurement_units.pressure.bar`)}</>}
							value={result.toString()}
						/>
						<Result
							className="grc__result-value-q"
							id={`grc-q-${i}`}
							label={<></>}
							// unit={<>{t(`common:measurement_units.q.thousand_m3_day`)}</>}
							value={resultsQ[i].toString()}
						/>
					</div>
					);
				})}
			</div>
			{secondWell &&
				<div className="grc__results-well2">
					<div className="grc__results_column_names">
						<div>
							<span>P </span>
							<span className="unit-font-size">
								<Trans
									ns={'gasRateCritical'}
									key={i18n.language}
									i18nKey={t(`measurement_units.pressure.bar`)}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							</span>
						</div>
						<div>
							<span>Q </span>
							<span className="unit-font-size">
								<Trans
									ns={'gasRateCritical'}
									key={i18n.language}
									i18nKey={t(`measurement_units.q.thousand_m3_day`)}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							</span>
						</div>
					</div>

					{resultsP.map((result, i) => {
						return (<div className="grc__result_row result-row" key={`grc-row-${i}`}>
							<Result
								className="grc__result-value-p"
								id={`grc-p-${i}`}
								label={<></>}
								// unit={<>{t(`common:measurement_units.pressure.bar`)}</>}
								value={result.toString()}
							/>
							<Result
								className="grc__result-value-q"
								id={`grc-q-${i}`}
								label={<></>}
								// unit={<>{t(`common:measurement_units.q.thousand_m3_day`)}</>}
								value={resultsQ[i].toString()}
							/>
						</div>
						);
					})}
				</div>}
		</fieldset>
	)
}

export default ResultsSection;